var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('BaseContainer',{staticClass:"main-footer__container"},[_c('p',{staticClass:"main-footer__info"},[_vm._v("© "+_vm._s(_vm.currentYear)+" — by SS")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }